import {
  CREATE_FULFILLMENT_SUCCESS,
  CREATE_FULFILLMENT_FAILED,
  CREATE_FULFILLMENT_PENDING
} from "../constants/actionConstants";

const initialState = {
  fulfillment: null,
  loading: true
};

export const postFulfillment = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_FULFILLMENT_PENDING:
      return Object.assign({}, state, { loading: true });
    case CREATE_FULFILLMENT_SUCCESS:
      return Object.assign({}, state, {
        success: action.payload
      });
    case CREATE_FULFILLMENT_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
